<template>
    <o-table :title="$t('sandoz.wholesalers')" ref="tableList" url="/api/wholesalers">
        <template slot="filter">
            <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                <o-filter-text :title="$t('sandoz.wholesaler')" column="wholesaler"
                               :prepend-percentage="true"></o-filter-text>
                <o-filter-select :items="yesNo" :title="$t('sandoz.enabled_for_kuko')"
                                 column="enabled_for_kuko" value-field="value"
                                 text-field="text"></o-filter-select>
                <o-filter-select :items="yesNo" :title="$t('sandoz.enable_for_pass_through')"
                                 column="enable_for_pass_through" value-field="value"
                                 text-field="text"></o-filter-select>
                <o-filter-select :items="yesNo" :title="$t('sandoz.enabled_for_chargebacks')"
                                 column="enabled_for_chargebacks" value-field="value"
                                 text-field="text"></o-filter-select>
                <o-filter-text :title="$t('sandoz.kuko_recipient')" column="kuko_recipient"
                               :prepend-percentage="true"></o-filter-text>
                <o-filter-text :title="$t('sandoz.dwh_name')" column="dwh_name"
                               :prepend-percentage="true"></o-filter-text>
            </o-filter>
        </template>
        <template slot="head">
            <o-table-header column="wholesaler">{{$t('sandoz.wholesaler')}}</o-table-header>
            <o-table-header column="enabled_for_kuko">{{$t('sandoz.enabled_for_kuko')}}</o-table-header>
            <o-table-header column="enable_for_pass_through">{{$t('sandoz.enable_for_pass_through')}}</o-table-header>
            <o-table-header column="enabled_for_chargebacks">{{$t('sandoz.enabled_for_chargebacks')}}</o-table-header>
            <o-table-header column="kuko_Recipient">{{$t('sandoz.kuko_recipient')}}</o-table-header>
        </template>
        <template slot="body" slot-scope="props">
            <td>{{ props.item.wholesaler }}</td>
            <td>{{ props.item.enabled_for_kuko ? $t('sandoz.yes') : $t('sandoz.no') }}</td>
            <td>{{ props.item.enable_for_pass_through ? $t('sandoz.yes') : $t('sandoz.no') }}</td>
            <td>{{ props.item.enabled_for_chargebacks ? $t('sandoz.yes') : $t('sandoz.no') }}</td>
            <td>{{ props.item.kuko_recipient }}</td>
        </template>
    </o-table>
</template>

<script>
export default {
  data: () => ({
    yesNo: []
  }),
  created() {
    this.yesNo = [
      {value: 1, text: this.$i18n.t('sandoz.yes')},
      {value: 0, text: this.$i18n.t('sandoz.no')}
    ]
  }
}
</script>
